import React from 'react';
import { useAssessment, useInstrumentConfig } from '../contexts/AssessmentContext';
export function Footer() {
  const {
    participantId
  } = useAssessment();
  const config = useInstrumentConfig();
  return <footer className="border-t border-slate-200 bg-white" data-id="element-96" data-mp="32onjn0nshk7w">
      <div className="mx-auto flex max-w-[1600px] flex-wrap items-center gap-x-3 gap-y-1 px-6 py-3 font-mono-num text-[11px] text-slate-400" data-id="element-97" data-mp="32m1c310wf4po">
        <span data-id="element-98" data-mp="3ug3f7k7bqha9">
          {config.id} {config.version}
        </span>
        <span aria-hidden="true" data-id="element-99" data-mp="38h4x8q3ngkf">·</span>
        <span data-id="element-100" data-mp="37ftv4932u2p">library {config.hash}</span>
        <span aria-hidden="true" data-id="element-101" data-mp="36d26u3xsnlq">·</span>
        <span data-id="element-102" data-mp="3lf5bl30ssbs7">participant {participantId || '—'}</span>
      </div>
    </footer>;
}